import React from "react";
import { CreateNFeContext } from "../../../../Context";
import Text from "../../../../../../../../_components/Text";
import { _Input } from "../../../../../../../../_components/Input";

import { PaymentContext } from "../../context";
import { useChangeDiscountValue } from "./hooks";

export default (props) => {
  const createNFeContext = React.useContext(CreateNFeContext);
  const paymentContext = React.useContext(PaymentContext);
  const setDiscount = useChangeDiscountValue();

  return (
    <div className="my-3">
      <Text fontSize="1.1em" color="primary">
        Desconto
      </Text>
      <_Input
        value={createNFeContext.nfe.identification.discount_value}
        disabled={paymentContext.disabled}
        onChange={setDiscount}
        type="currency"
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/NFePaymentShipping/Payments/components/Discount/index.jsx